import { render, staticRenderFns } from "./QuizzSentence.vue?vue&type=template&id=43776536&"
import script from "./QuizzSentence.vue?vue&type=script&lang=ts&"
export * from "./QuizzSentence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports